import { Pipe, PipeTransform } from '@angular/core';
import { NormalizerHelper } from 'src/app/core/helpers/normalizer.helper';

@Pipe({
  name: 'removeCaracteres',
})
export class RemoverCaracteresPipe implements PipeTransform {
  transform(str: string, caracteresParaRemover: string[]): string {
    return NormalizerHelper.removeCaracteres(str, caracteresParaRemover);
  }
}
